import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens a modal that a disabled turbo frame renders on demand (Ui::Modal::ButtonComponent.on_demand_data): a page
// listing practitioners holds one such frame per practitioner instead of their profile modals. The first click
// enables the frame, which then loads its src; every click shows the modal once it is in the page. The trigger is
// passed as relatedTarget, as data-bs-toggle does (form--section-nav reads its data-section-nav-key).
export default class extends Controller {
  async open (event) {
    event.preventDefault()

    const trigger = event.currentTarget
    const { modalId, frameId } = event.params
    const modal = document.getElementById(modalId) || await this.load(frameId, modalId, trigger)
    if (!modal) return

    Modal.getOrCreateInstance(modal).show(trigger)
  }

  async load (frameId, modalId, trigger) {
    const frame = document.getElementById(frameId)
    if (!frame) return null

    trigger.setAttribute("aria-busy", "true")
    try {
      frame.disabled = false
      await frame.loaded
    } catch {
      return null
    } finally {
      trigger.removeAttribute("aria-busy")
    }

    return document.getElementById(modalId)
  }
}
